// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2WGwx{min-height:100vh;width:100%}._2WGwx,.Y14R0{display:-ms-flexbox;display:flex}.Y14R0{-ms-flex-direction:column;flex-direction:column;margin:auto}.Y14R0>svg{width:100%}", ""]);
// Exports
exports.locals = {
	"root": "_2WGwx",
	"root__container": "Y14R0"
};
module.exports = exports;
